export enum Prioridade {
  URGENTE = 'favorito',
  IMPORTANTE = 'importante',
  NORMAL = 'normal'
}

export enum Status {
  PENDENTE = 'pendente',
  CONCLUIDA = 'concluida'
}
